import React, { useState } from 'react';
import { Typography, Button } from '@material-ui/core';
import PropTypes from 'prop-types';

import VideoUploader from 'sharedComponents/VideoUploader';
import VideoPlayer from 'sharedComponents/VideoPlayer/VideoPlayer';
import { isBlank } from 'utils/helperMethods';
import { useTranslation } from 'react-i18next';
import Dropzone from 'sharedComponents/Dropzone';

import useStyles from './useStyles';

const WIDTH = 150;

const ProfileVideo = props => {
  const { label, value, saveProfileVideo } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  const [openVideoMessageSendPopup, setOpenVideoMessageSendPopup] = useState(false);
  const [videoFile, setVideoFile] = useState(null);

  const closeVideoPopup = () => {
    setOpenVideoMessageSendPopup(false);
    setVideoFile(null);
  };

  const handleOnDrop = file => {
    const currentFile = file[0];
    setVideoFile(currentFile);
    setOpenVideoMessageSendPopup(true);
  };

  const handleSaveProfileVideo = cachedVideo => {
    saveProfileVideo({ profileVideo: cachedVideo });
    closeVideoPopup();
  };

  return (
    <div className={classes.container}>
      <Typography variant="body2" className={classes.label}>
        {label}
      </Typography>
      <div className={classes.content}>
        {!isBlank(value) && <VideoPlayer url={value} width={`${WIDTH}`} className={classes.player} />}
        <Dropzone handleOnDrop={handleOnDrop}>
          <Button variant="outlined" color="primary" className={classes.button}>
            {isBlank(value)
              ? t('components.ProfileForm.buttons.uploadVideo')
              : t('components.ProfileForm.buttons.changeVideo')}
          </Button>
        </Dropzone>
      </div>
      {openVideoMessageSendPopup && (
        <VideoUploader onClose={closeVideoPopup} videoFile={videoFile} onSend={handleSaveProfileVideo} type="upload" />
      )}
    </div>
  );
};

ProfileVideo.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
};

ProfileVideo.defaultProps = {
  value: '',
};

export default ProfileVideo;



// WEBPACK FOOTER //
// ./src/components/LoanOfficerSettings/components/Profile/components/ProfileForm/components/ProfileVideo/ProfileVideo.js